var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineniqLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 60,
    viewBox: "0 0 67 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6943 60H13.6119C10.003 59.9959 6.54309 58.5604 3.99126 56.0085C1.43942 53.4566 0.00403099 49.9967 0 46.3878V0H8.00305V46.3878C8.00463 47.8749 8.59605 49.3007 9.64756 50.3522C10.6991 51.4038 12.1248 51.9953 13.6119 51.997H66.6943V60Z",
    fill: "#17B091"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4931 38.8388L21.1799 38.8448V12.33H13.1769V42.8524C13.1803 43.9136 13.6038 44.9304 14.3548 45.6803C15.1058 46.4301 16.1232 46.8521 17.1844 46.8539L55.9438 46.8293L35.4931 38.8388ZM57.2306 35.6622L56.6889 35.4529L34.4957 26.803V20.3763L57.2306 20.3703V32.5901L65.2337 35.7048V16.3688C65.2331 15.3076 64.8113 14.2902 64.061 13.5398C63.3107 12.7895 62.2932 12.3678 61.2321 12.3672L30.4942 12.3732C29.4329 12.3732 28.4151 12.7948 27.6647 13.5453C26.9142 14.2957 26.4926 15.3135 26.4926 16.3748V29.5366C26.4905 30.3432 26.7329 31.1315 27.188 31.7975C27.643 32.4634 28.2892 32.9758 29.0414 33.267L41.8648 38.2659L43.3359 38.8388L62.9128 46.4595L63.8792 46.8353L66.6987 47.9312V39.3619L57.2306 35.6622Z",
    fill: "#2F2F3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1779 0H13.1805V7.99703H21.1779V0Z",
    fill: "#2F2F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineniqLogo);
export default __webpack_public_path__ + "static/media/lineniq-logo.51aed267cec72227ed04d3c7aeaf1ff4.svg";
export { ForwardRef as ReactComponent };